module.exports = __webpack_public_path__ + "assets/round-checkbox-off.480709ee.svg";